import React from 'react'
import 'react-toastify/dist/ReactToastify.css'
import Footer from '../navigation/Footer'
import LayoutModals from './LayoutModals'
import { IntercomProvider } from 'react-use-intercom'
import HeaderV2 from '../navigation/HeaderV2'

type LayoutProps = {
  children: React.ReactNode
}

export default function ArticlesLayout({ children }: LayoutProps) {
  return (
    <IntercomProvider appId={'u9r1twrv'} autoBoot={true} initializeDelay={3000}>
      <>
        <div className='fixed inset-0 flex justify-center sm:px-8'>
          <div className='flex w-full max-w-7xl lg:px-8'>
            <div className='w-full bg-darul-900' />
          </div>
        </div>
        <div className={'bg flex min-h-screen flex-col'}>
          <HeaderV2 isSticky={true} />

          <main className={'mt-16 grow'}>{children}</main>

          <Footer />

          <LayoutModals />
        </div>
      </>
    </IntercomProvider>
  )
}
